import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';
import parse from 'date-fns/parse';

@Pipe({
  name: 'timeByMinutes',
})
export class TimeByMinutesPipe implements PipeTransform {
  transform(timeInMinutes: number, isMilitary = false): string {
    if (!timeInMinutes && timeInMinutes !== 0) return '';

    const militaryTime =
      timeInMinutes === 0
        ? '00:00'
        : `${(timeInMinutes / 60).toString().split('.')[0]}:${(timeInMinutes % 60).toString().padStart(2, '0')}`;

    return isMilitary ? militaryTime : format(parse(militaryTime, 'HH:mm', new Date()), 'hh:mm aa');
  }
}
